import * as React from 'react';
import { Input } from '@shared/shared-shadcn-ui';
import { cn } from '@shared/shared-utils';
import { sendFormFieldInteractionEvent } from '@shared/shared-gtm-tracker';
import { ComponentProps } from 'react';

type Properties = ComponentProps<'input'> & {
  hasError?: boolean;
};

const FormInput = React.forwardRef<HTMLInputElement, Properties>(
  ({ className, onBlur, hasError = false, ...props }, ref) => {
    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
      // Call react-hook-form’s onBlur handler if it exists
      onBlur?.(e);
      // Call GTM tracking
      sendFormFieldInteractionEvent(e);
    };

    return (
      <Input
        ref={ref}
        {...props}
        className={cn(
          'bg-white !text-[18px] lg:!text-[20px] !py-5 leading-[23px] font-bold text-ogn-dark border-[rgba(0,_0,_0,0.12)] !rounded-[4px] !w-full',
          hasError && 'border-red-500',
          className,
        )}
        onBlur={handleBlur}
      />
    );
  },
);

FormInput.displayName = 'FormInput';

export { FormInput };
